import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationTypeCodeLabels } from '../../constants/ApplicationTypeCodeLabels';
import { ModalType } from '../../constants/ModalType';
import { CreditClaim } from '../../types';
import ActionModal from '../ActionModal';
import Text, { TextStyle } from '../Text';
import { getEarnerName } from './index';

interface Props {
  claim: CreditClaim;
}

const PRARestoreFailedModal: React.FunctionComponent<Props> = ({ claim }) => {
  const modalId = `${ModalType.PRARestoreFailed}-${claim.id}`;
  const errorMessage = useSelector((state: any) => state.modal.payloads?.[modalId]);

  return (
    <ActionModal modalId={`${ModalType.PRARestoreFailed}-${claim.id}`} title="Restore Failed" showButtons={false}>
      <Text textStyle={TextStyle.Label}>Application</Text>
      <div style={{ marginBottom: '1rem' }} />
      <Text textStyle={TextStyle.Default} bold={true}>
        {getEarnerName(claim)}
      </Text>
      <Text textStyle={TextStyle.Default}>{ApplicationTypeCodeLabels[claim.applicationTypeCode || '']}</Text>
      <div style={{ marginBottom: '3rem' }} />
      <Text textStyle={TextStyle.Default}>{errorMessage}</Text>
    </ActionModal>
  );
};

export default PRARestoreFailedModal;
